// Builds an `<img srcset>` from a serialized image's `sizes`
// (`Image.sizes_for`: an unsigned base URL plus per-width imgix signatures).
export const generateSrcset = (sizes: any): string | null => {
  if (!sizes || !sizes.base_url || !sizes.data) {
    return null;
  }

  const sizesData = Object.values(sizes.data) as any[];
  if (sizesData.length === 0) {
    return null;
  }

  const separator = sizes.base_url.includes("?") ? "&" : "?";

  const validEntries = sizesData
    .filter((size: any) => size.s && size.w)
    .sort((a: any, b: any) => a.w - b.w)
    .map((size: any) => {
      let url = `${sizes.base_url}${separator}w=${size.w}`;
      if (size.h) {
        url += `&h=${size.h}`;
      }
      return `${url}&s=${size.s} ${size.w}w`;
    });

  return validEntries.length > 0 ? validEntries.join(", ") : null;
};
